import { Stack } from "@mui/material";
import React from "react";

const PulseAnimation2 = () => {
  return (
    <div>
      <Stack
        sx={{
          position: "relative",
          width: { xs: "32px", sm: "60px" },
          height: { xs: "32px", sm: "60px" },
          // background: "#FFFFFF",
          background: "linear-gradient(to right, #66e0ff,#ebf4ff)",
          borderRadius: "50%",
        }}
      >
        {[...Array(4)].map((_, i) => (
          <span
            key={i}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background: "inherit",
              borderRadius: "inherit",
              right: "5px",
              opacity: 0.8,
              animation: "pulseAnimate 4s ease-out infinite",
              animationDelay: `${i}s`,
            }}
          ></span>
        ))}
      </Stack>

      {/* Inline keyframes for animations */}
      <style>
        {`
          @keyframes colorAnimate {
            100% { 
              filter: hue-rotate(360deg);
            }
          }

          @keyframes pulseAnimate {
            10% {
              opacity: 0;
              transform: scale(2);
            }
          }
        `}
      </style>
    </div>
  );
};

export default PulseAnimation2;
